import { CLIENT_MANAGER, ENTERPRISE_READER } from '../../../../../util/userGroups'

export const REPORTING_ACCESS = 'reporting:access'
export const PLAYLIST_MANAGE_PLAYLIST = 'playlist:manage-playlist'
export const MSA_ACCESS = 'msa:access'

export const SUPPORTED_FEATURES_BY_ROLE = {
  [CLIENT_MANAGER]: {
    [REPORTING_ACCESS]: 'Reporting',
    [PLAYLIST_MANAGE_PLAYLIST]: 'Manage Playlist',
    [MSA_ACCESS]: 'Manager Skills Assessments'
  },
  [ENTERPRISE_READER]: {
    [MSA_ACCESS]: 'Manager Skills Assessments'
  }
}
